import { configs } from '@hero/configs';

function useGetProductSkuImages({ product }) {
  const expensiveProductSku = product?.skus?.reduce((acc, sku) => {
    if (sku?.price > acc?.price) {
      return sku;
    }
    return acc;
  }, {});

  let images = [];
  if (configs?.general?.useProductSkuImages && !!expensiveProductSku?.images?.length) {
    images = [expensiveProductSku.images[0]]; //! TODO: use expensiveProductSku?.images after magento fixed sku images by correct images
  } else if (product.images) {
    images = product.images;
  }
  return images;
}

export { useGetProductSkuImages };
